import { create } from 'apisauce'
import store from '../store'
import handleNetworkError from '../actions/network'
import { refreshUserToken } from '../actions/user'
import { getUnsecureAPIEndpoint } from '../utils/apiConstants'

const baseURL = getUnsecureAPIEndpoint()
const apiUnsecure = create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
})


apiUnsecure.axiosInstance.interceptors.request.use(
  (config) => {
    const newConfig = {
      ...config,
      headers: { ...config.headers,
        // FIX: for GET requests
        // more in: https://github.com/infinitered/apisauce/issues/120
        'Content-Type': 'application/json',
      },
    }
    return newConfig
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error)
  },
)


apiUnsecure.axiosInstance.interceptors.response.use(
  response => (
    response
  ), error => (
    new Promise(() => {
      if (error.response) {
        const statusCode = error.response.status
        if (statusCode === 401) {
          // call to login
          // return store.dispatch(logout())
        } else if (statusCode === 403) {
          return store.dispatch(refreshUserToken())
        }
        return store.dispatch(handleNetworkError(error.response.status, error.response.data))
      }
      return store.dispatch(handleNetworkError(0))
    })
  ))

apiUnsecure.axiosInstance.interceptors.request.use((config) => {
  return config
}, (error) => {
  console.log(error)
  return Promise.reject(error)
})
export default apiUnsecure
